import { Loading } from "@podtrac/common/components/Loading";
import React, { useState } from "react";

export default function Frame(props) {
    const [loading, setLoading] = useState(true);

    const frameLoad = event => {
        setLoading(false);

        const target = event.target;

        target.height = target.contentWindow.document.body.scrollHeight;
        target.contentWindow.document.body.style.overflow = "hidden";


        const observer = new MutationObserver((mutationList, observer) => {
            target.height = target.contentWindow.document.body.scrollHeight;
        });

        observer.observe(target.contentWindow.document.body, {
            attributes: true, childList: true, subtree: true
        });

        target.contentWindow.onbeforeunload = () => {
            observer.disconnect();
            setLoading(true);
            setTimeout(() => setLoading(false), 10 * 1000);
        };

    };

    return (
        <div
            style={{
                position: "relative"
            }}
        >
            {loading ? (
                <div
                    onClick={() => setLoading(false)}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: "50%",
                        transform: "translate(-50%, 0)",
                        border: "none",
                        zIndex: 100,
                        background: "#ffffff66"
                    }}
                >
                    <Loading />
                </div>
            ) : null}
            <iframe
                onLoad={frameLoad}
                onError={() => console.log("error")}
                style={{
                    width: "100%",
                    border: "none"
                }}
                {...props}
            />
        </div>
    );
}
